(() => {
    'use strict';

    angular
        .module('uwAgenda.agenda')
        .directive(
            'agendaAppointmentLanguage', 
            [
                '$document', 
                'Languages', 
                buildDirective
            ]
        );
    
    function buildDirective($document, Languages) {
        return {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-language.template.html',
            scope: {
                language: '=',
                defaultLanguage: '='
            },
            link: link
        };
        
        function link(scope, element) {
            initScope(scope, Languages);
            addWatchers(scope);
            setValues(scope);
        }
    }

    function initScope(scope, Languages) {
        scope.Languages = Languages;

        scope.setLanguage = (id) => {
            scope.language = id;

            scope.selectedLanguageId = id;
            switch (id) {
                case Languages.English.id: scope.selectedLanguageName = Languages.English.iso; break;
                case Languages.German.id: scope.selectedLanguageName = Languages.German.iso; break;
                case Languages.Dutch.id: scope.selectedLanguageName = Languages.Dutch.iso; break;
                case Languages.French.id: scope.selectedLanguageName = Languages.French.iso; break;
                default: scope.selectedLanguageName = Languages.Unknown.iso; break;
            }
        };
    }

    function addWatchers(scope) {
        // listen on outside language change
        let languageWatch = scope.$watch(() => {
            return scope.language;
        }, (newVal, oldVal) => {
            if (!newVal) {
                return;
            } else if (newVal === oldVal) {
                return;
            }

            scope.setLanguage(newVal);
        });

        // remove watchers on destroy
        scope.$on('$destroy', () => {
            languageWatch();
        });
    }

    function setValues(scope) {
        if (scope.language === undefined || scope.language === 0) {
            if (scope.defaultLanguage === undefined || scope.defaultLanguage === 0) {
                scope.setLanguage(Language.Dutch.id);
            } else {
                scope.setLanguage(scope.defaultLanguage);
            }
        } else {
            scope.setLanguage(scope.language);
        }
    }
})();